import { render, staticRenderFns } from "./EditorElementInfoEffects.vue?vue&type=template&id=49382ded&lang=pug"
import script from "./EditorElementInfoEffects.vue?vue&type=script&lang=js"
export * from "./EditorElementInfoEffects.vue?vue&type=script&lang=js"
import style0 from "./EditorElementInfoEffects.vue?vue&type=style&index=0&id=49382ded&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports